<template>
    <div class="vh-footer">
        <div class="vh-container vh-text-center">
            <div>
                <small class="vh-inline">
                    <a class="vh-link-reset vh-text-primary"
                        :href="`${webUrl}/about-us`" target="new">
                        About Us
                    </a>
                </small>
                &middot;
                <small class="vh-inline">
                    <a class="vh-link-reset vh-text-primary"
                        :href="`${webUrl}/terms-of-service`" target="new">
                        Terms of Service
                    </a>
                </small>
                &middot;
                <small class="vh-inline">
                    <a class="vh-link-reset vh-text-primary"
                        :href="`${webUrl}/privacy-policy`" target="new">
                        Privacy Policy
                    </a>
                </small>
            </div>
            <div class="vh-margin-small-top">
                <p class="vh-margin-remove vh-text-muted vh-text-break">©  2019 - {{year}} VANTAGEHUNT, INC. All Rights Reserved.</p>
                <small class="vh-text-muted">version 2.8.1</small>
            </div>
        </div>
    </div>
</template>

<script>
export default
{
    computed:
    {
        year()
        {
            const date = new Date();
            return date.getFullYear();
        },

        webUrl()
        {
            return process.env.WEB_URL;
        },


    },
};
</script>

<style scoped>
    .vh-footer {
        position: relative;
        top: 25px;
        bottom: 0;
        width: 100%;
        background-color: #f9f9f9;
        padding-top: 20px;
        padding-bottom: 20px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/layouts/footer.vue